import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import LandingPage from "@/pages/LandingPage";
import AppShell from "@/layouts/AppShell";
import DashboardPage from "@/pages/DashboardPage";
import AccountsPage from "@/pages/AccountsPage";
import JournalsPage from "@/pages/JournalsPage";
import InvoicesPage from "@/pages/InvoicesPage";
import BankPage from "@/pages/BankPage";
import ReportsPage from "@/pages/ReportsPage";
import ConsolidationPage from "@/pages/ConsolidationPage";
import CompaniesPage from "@/pages/CompaniesPage";
import TeamPage from "@/pages/TeamPage";
import AuthCallback from "@/pages/AuthCallback";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import PublicInvoicePage from "@/pages/PublicInvoicePage";
import PaystackCallback from "@/pages/PaystackCallback";
import RemindersPage from "@/pages/RemindersPage";
import SettingsPage from "@/pages/SettingsPage";
import BankAccountsPage from "@/pages/BankAccountsPage";
import IntercompanyPage from "@/pages/IntercompanyPage";
import SalesDataPage from "@/pages/SalesDataPage";
import CustomersPage from "@/pages/CustomersPage";
import SuppliersPage from "@/pages/SuppliersPage";
import MTDPage from "@/pages/MTDPage";
import SubscriptionPage from "@/pages/SubscriptionPage";
import EmployeesPage from "@/pages/EmployeesPage";
import ExpensesPage from "@/pages/ExpensesPage";
import AdminUsersPage from "@/pages/AdminUsersPage";
import AcceptInvitePage from "@/pages/AcceptInvitePage";
import GlDetailPage from "@/pages/GlDetailPage";
import "@/App.css";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="overline">Loading ledger…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <Toaster richColors position="top-right" />
        <AuthCallback />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/pay/:token" element={<PublicInvoicePage />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/invite/:token" element={<AcceptInvitePage />} />
          <Route
            element={
              <Protected>
                <AppShell />
              </Protected>
            }
          >
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/accounts" element={<AccountsPage />} />
            <Route path="/journals" element={<JournalsPage />} />
            <Route path="/invoices" element={<InvoicesPage />} />
            <Route path="/customers" element={<CustomersPage />} />
            <Route path="/suppliers" element={<SuppliersPage />} />
            <Route path="/mtd" element={<MTDPage />} />
            <Route path="/subscription" element={<SubscriptionPage />} />
            <Route path="/bank" element={<BankPage />} />
            <Route path="/bank-accounts" element={<BankAccountsPage />} />
            <Route path="/intercompany" element={<IntercompanyPage />} />
            <Route path="/sales" element={<SalesDataPage />} />
            <Route path="/reminders" element={<RemindersPage />} />
            <Route path="/reports" element={<ReportsPage />} />
            <Route path="/consolidation" element={<ConsolidationPage />} />
            <Route path="/companies" element={<CompaniesPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/employees" element={<EmployeesPage />} />
            <Route path="/expenses" element={<ExpensesPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/admin" element={<AdminUsersPage />} />
            <Route path="/reports/gl-detail" element={<GlDetailPage />} />
          </Route>
        </Routes>
      </div>
    </AuthProvider>
  );
}

export default App;
